import { baseURL } from '../../../functions/baseUrl'
import {useEffect, useRef, useState} from "react";
import {FullImage, Image} from "./style";
import Modal from '@mui/material/Modal';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress'

const style = {
  position: 'relative',
  width: '100%',
  height: '100%',
  overflow: 'auto',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};

const iconStyle = {
  position: 'absolute',
  top: '5px',
  right: '5px',
  color: '#c5c5c5',
  fontSize: '2.5rem'
};

export default function FileMessage(props) {
  const ref = useRef(null)
  const [image, setImage] = useState(null)
  useEffect( () => {
    const loadVoice = async () => {
      const audioSource = ref.current;
      // const cookies = document.cookie.split(";")

      const result = await fetch(`${baseURL}/download/${props.message.file.id}/`, {
        // headers: {
        //   Authorization: cookies[cookies?.length - 1]
        // }
      });

      const blob = await result.blob();

      if (blob) {
        audioSource.src = URL.createObjectURL(blob);
        setImage(URL.createObjectURL(blob))
      } else {
        console.warn("Can not load");
      }
    }

    loadVoice()
  }, [])

  const [seeFullSize, setFullSize] = useState(false)

  return (
   <span style={{display: 'flex', justifyContent: 'center', alignItems: "center"}}>
     {!image && <CircularProgress size={15} style={{ position: 'absolute' }} />}
    <Image
      ref={ref}
      width='180px'
      alt=''
      onClick={() => setFullSize(true)}
    />
     <Modal
      open={seeFullSize}
      onClose={() => setFullSize(false)}
     >
       <Box sx={style}>
         <HighlightOffIcon
            sx={iconStyle}
            onClick={() => setFullSize(false)}
         />
         <FullImage
          alt=''
          src={image}
         />
       </Box>
     </Modal>
   </span>
  );
}
